import { Component, Vue, Prop } from 'vue-property-decorator';

import SmartButton from 'tivigi/src/components/SmartButton/SmartButton'
import WithRender from './NavbarButton.html';


@WithRender
@Component({
    components: {
        SmartButton
    }
})
export default class Smartbutton extends Vue {

 


    mShowNavbar : boolean = false

    get show_navbar() : boolean {
        return this.mShowNavbar
    }

    set show_navbar(newval) {
       this.mShowNavbar = newval
       //@ts-ignore
       document.showNavbar = newval
    }

  
    
}
